import { stringify as qs_stringify } from "qs";

export const directionsUrl = (wsPointOfSaleLocation) => {
	// https://developers.google.com/maps/documentation/urls/get-started#directions-action
	return "https://www.google.com/maps/dir/?" + qs_stringify({
		api: 1,
		destination: `${wsPointOfSaleLocation.address.address1}, ${wsPointOfSaleLocation.address.city}, ${wsPointOfSaleLocation.address.state}, ${wsPointOfSaleLocation.address.postalCode}`,
	});
};
